import type { PaginatedResponse, SubscriptionListItemResponse } from '@tabita/contracts';
import { apiRequest } from './api-client';

export interface ListSubscriptionsParams {
  readonly search?: string;
  readonly status?: string;
  readonly moduleKey?: string;
  readonly cursor?: string;
  readonly limit?: number;
}

/** Platform-operator endpoint — gated on `platform.tenant.read`, not a tenant resource. */
export const platformSubscriptionsApi = {
  list(params: ListSubscriptionsParams = {}, signal?: AbortSignal) {
    return apiRequest<PaginatedResponse<SubscriptionListItemResponse>>('/platform/subscriptions', {
      query: { ...params },
      signal,
    });
  },
};
